import { render, staticRenderFns } from "./demais-dispendios.vue?vue&type=template&id=68fa29b5&scoped=true&"
import script from "./demais-dispendios.vue?vue&type=script&lang=js&"
export * from "./demais-dispendios.vue?vue&type=script&lang=js&"
import style0 from "./demais-dispendios.vue?vue&type=style&index=0&id=68fa29b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fa29b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
